module.exports = __webpack_public_path__ + "static/img/syt zfb.bb57d08e.svg";